module.exports = __webpack_public_path__ + "static/img/img_2.20def85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_2.png
// module id = IRP+
// module chunks = 1